import { FormatUnderlineIcon } from './FormatUnderlineIcon';

/**
 * author: Google
 * id DD218F3D-C302-477A-9B9F-482813328DE6
 * name format-underline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-underline.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatUnderlinedIcon = FormatUnderlineIcon;
export default FormatUnderlinedIcon